// 서버/클라이언트/미들웨어 공용 순수 locale 유틸
// React 훅 없음 — Edge Runtime 포함 모든 환경에서 사용 가능

export const LOCALES = ["ko", "en", "ja", "zh", "th"];
export const DEFAULT_LOCALE = "ko";
export const LOCALE_COOKIE = "locale";

export const isValidLocale = (l) => LOCALES.includes(l);

export const isExternal = (href = "") =>
  /^https?:\/\//i.test(href) || href.startsWith("tel:") || href.startsWith("mailto:");

export const normHref = (href = "/") => {
  if (!href) return "/";
  if (isExternal(href)) return href.trim();
  return href.startsWith("/") ? href.trim() : `/${href.trim()}`;
};

export const getLocaleFromPath = (pathname = "/") => {
  const parts = String(pathname || "/").split("/").filter(Boolean);
  const maybe = parts[0];
  return isValidLocale(maybe) ? maybe : DEFAULT_LOCALE;
};

export const labelOf = (label, locale = DEFAULT_LOCALE) => {
  if (typeof label === "string") return label;
  if (label && typeof label === "object") {
    return (
      label[locale] ??
      label[DEFAULT_LOCALE] ??
      label.ko ??
      label.en ??
      label.ja ??
      label.zh ??
      label.th ??
      ""
    );
  }
  return "";
};

export const pickLocale = (obj, locale = DEFAULT_LOCALE) => {
  if (obj == null) return "";
  if (typeof obj !== "object") return String(obj);
  return (
    obj[locale] ??
    obj[DEFAULT_LOCALE] ??
    obj.ko ??
    obj.en ??
    obj.ja ??
    obj.zh ??
    obj.th ??
    ""
  );
};

export const t = pickLocale;

// 외국어 주소 /{lang}/X 는 rewrite 로 /main/X 를 보여 주므로, /main/X 링크(관리자 메뉴의 /main/myTickets 등)에
// 언어만 붙이면 /en/main/X → 404. 외국어일 때는 /main 을 뗀다 (locale-url.js 와 같은 규칙).
const MAIN_PREFIX_RE = /^\/main(?=[/?#]|$)/;

export const withLocaleHref = (href = "/", locale = DEFAULT_LOCALE) => {
  if (isExternal(href)) return href;
  const p = normHref(href);
  const parts = p.split("/").filter(Boolean);
  const alreadyPrefixed = parts.length > 0 && LOCALES.includes(parts[0]);

  if (locale === DEFAULT_LOCALE) {
    return alreadyPrefixed ? "/" + parts.slice(1).join("/") : p;
  }
  if (alreadyPrefixed) return p;
  return MAIN_PREFIX_RE.test(p) ? `/${locale}${p.replace(MAIN_PREFIX_RE, "")}` : `/${locale}${p}`;
};

export const replaceLocaleInPath = (pathname = "/", nextLocale = DEFAULT_LOCALE) => {
  const safe = pathname || "/";
  const parts = safe.split("/").filter(Boolean);
  const hasLocale = parts.length > 0 && LOCALES.includes(parts[0]);

  if (nextLocale === DEFAULT_LOCALE) {
    const rest = hasLocale ? parts.slice(1) : parts;
    return "/" + rest.join("/");
  }
  if (hasLocale) {
    parts[0] = nextLocale;
    return "/" + parts.join("/");
  }
  return `/${nextLocale}` + (safe === "/" ? "" : safe);
};

export const isActiveForLocale = (item = {}, locale = DEFAULT_LOCALE) => {
  if (item.active === false) return false;
  const map = item.activeByLocale;
  if (!map || typeof map !== "object") return true;
  const v = map[locale];
  return typeof v === "boolean" ? v : true;
};

export const ensureLocaleObj = (v) => {
  const out = { ko: "", en: "", ja: "", zh: "", th: "" };
  if (!v) return out;
  if (typeof v === "string") { out.ko = v; return out; }
  LOCALES.forEach((l) => { if (typeof v[l] === "string") out[l] = v[l]; });
  return out;
};

export const compactLocaleObj = (obj) => {
  const o = {};
  LOCALES.forEach((l) => {
    const val = obj?.[l];
    if (typeof val === "string" && val.trim()) o[l] = val.trim();
  });
  return o;
};
